import { Box, Flex } from '@modusign/design-system';
import { useDispatch } from 'react-redux';

import { TextFieldFontLoader } from '@app/components/TextField';
import { supportedFieldsTemplateFieldSetupPage } from '@app/constants/supportedFieldsPerEditor';
import MouseFieldPlaceholder from '@app/containers/MouseFieldPlaceholder';
import PDFSetupBusinessPage from '@app/containers/PDFConfigurableBusinessPages/PDFSetupBusinessPage';
import TemplateFieldFooter from '@app/containers/TemplateFieldFooter';
import DocumentSetupSecondStepBoards from '@app/features/apply-react-signing/components/FieldSetupStep/ParticipantFIeldStatusBoards';
import { usePDF } from '@app/hooks/usePDF';
import PDFDocumentContentLayout from '@app/libs/reactPdfJs/components/PDFDocumentContentLayout';
import PDFDocumentPageLayout from '@app/libs/reactPdfJs/components/PDFDocumentPageLayout';
import PDFContainer from '@app/libs/reactPdfJs/containers/PDFContainer';
import { zoomIn, zoomOut } from '@app/libs/reactPdfJs/store/actions';

import TemplateHeader from '../../TemplateHeader';
import TemplateLoadingSpinner from '../../TemplateLoadingSpinner';

interface TemplateFieldSetupPageProps {
  handleNextRouteClick: () => void;
  handlePrevRouteClick: () => void;
}

function TemplateFieldSetupPage({
  handleNextRouteClick,
  handlePrevRouteClick,
}: TemplateFieldSetupPageProps) {
  const dispatch = useDispatch();

  const { pdf } = usePDF();

  const handleZoomIn = () => {
    dispatch(zoomIn());
  };

  const handleZoomOut = () => {
    dispatch(zoomOut());
  };

  return (
    <PDFDocumentPageLayout>
      <TextFieldFontLoader />
      <TemplateLoadingSpinner />
      <TemplateHeader
        currentStepIndex={2}
        isExchangeDocumentVisible
        progressStep="templateFieldSetup"
        onPDFZoomIn={handleZoomIn}
        onPDFZoomOut={handleZoomOut}
      />

      <PDFDocumentContentLayout>
        <MouseFieldPlaceholder />
        <Flex flex="1" height="100%" width="100%">
          <Box
            backgroundColor="lightGray25"
            className="
            Card
            Card--theme-editor
            RequestSettingPosition__joiner-card-block-box"
            minWidth="unset"
          >
            <DocumentSetupSecondStepBoards
              isTemplateSetting
              needAuthorityCheck={false}
              supportedFields={supportedFieldsTemplateFieldSetupPage}
            />
          </Box>
          {pdf && (
            <Box flex="1">
              <PDFContainer
                PDFBusinessPage={PDFSetupBusinessPage}
                disablePinchZoom
                src={pdf}
                thumbnailContainerClassName="hidden"
                useThumbnailViewer={false}
                viewerPT={220}
              />
            </Box>
          )}
        </Flex>
      </PDFDocumentContentLayout>
      <TemplateFieldFooter
        backButtonText="< 이전 단계로"
        nextButtonText="다음 단계로 >"
        onBackStepClick={handlePrevRouteClick}
        onNextStepClick={handleNextRouteClick}
      />
    </PDFDocumentPageLayout>
  );
}

export default TemplateFieldSetupPage;
